<template>
  <PopUpTemplate 
    :btn-name="t('resetRideModalButton')"
    :modal-title="t('resetRideModalTitle')"
    :confirm-text="t('resetRideModalConfirm')"
    :cancel-text="t('resetRideModalCancel')"
    :show-confirm-buttons="true"
    :on-confirm="handleResetConfirm"
  >
    <div class="reset-modal-content" :dir="isHebrew ? 'rtl' : 'ltr'">
      <div class="warning-icon">⚠️</div>
      <p class="warning-text">
        <strong>{{ t('resetRideModalWarningQuestion') }}</strong>
      </p>
      <p class="description-text">
        {{ t('resetRideModalDescriptionLine1') }}
        <br>
        <strong>{{ t('resetRideModalDescriptionLine2Strong') }}</strong>
      </p>
      <p class="irreversible-text">
        {{ t('resetRideModalIrreversible') }}
      </p>
    </div>
  </PopUpTemplate>
</template>

<script>
import { mapActions } from 'vuex';
import PopUpTemplate from './Pop-ups/PopUpTemplate.vue';
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: 'ResetRideModal',
  mixins: [translationMixin],
  components: {
    PopUpTemplate
  },
  props: {
    rideId: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    ...mapActions(['resetRideToOriginal']),
    handleResetConfirm() {
      this.resetRideToOriginal(this.rideId);
    }
  }
};
</script>

<style scoped>
.reset-modal-content {
  text-align: center;
  padding: 20px;
}

.warning-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.warning-text {
  color: #d9534f;
  font-size: 18px;
  margin-bottom: 15px;
}

.description-text {
  color: #333;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 15px;
}

.irreversible-text {
  color: #d9534f;
  font-size: 12px;
  font-style: italic;
  font-weight: bold;
}
</style> 